// 基本依赖
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"
// 页面
import Login from "@/components/Login";//登录页
import home from "@/components/home";//系统导航栏
import Menu from "@/views/sys_system/Menu";//操作菜单
import User from "@/views/sys_system/User";//用户管理
import SysRole from "@/views/sys_system/SysRole";//角色管理
import Dynamic from "@/views/sys_school/Dynamic";//动态管理
import School from "@/views/sys_school/School";//校园管理
import SchoolCommission from "@/views/sys_school/SchoolCommission";//分成配置
import index from "@/views/profile/index";//个人中心
import ParttimeAudit from "@/views/sys_audit/ParttimeAudit";//兼职负责人审核
import CampusUser from "@/views/sys_user/CampusUser";//普通用户管理
import CampusJob from "@/views/sys_user/CampusParttime";//普通用户管理
import ManagerAssignment from "@/views/sys_user/ManagerAssignment";//兼职负责人分配管理
import shopClassification from "@/views/shop/shopClassification";//店铺分类
import productClassification from "@/views/shop/productClassification";//商品分类
import shop from "@/views/shop/shop";//门面管理
// import order from "@/views/order/order";//订单中心
import selectOrder from '@/components/order/selectOrder';
import selectRefund from "@/components/order/selectRefund";
import product from "@/views/shop/product";
import Dashboard from "@/views/dashboard/Dashboard";//首页Dashboard
import ParttimeIncome from "@/views/income/ParttimeIncome";//兼职收入
import PlatformIncome from "@/views/income/PlatformIncome";//平台收入
import WithdrawalCenter from "@/views/income/WithdrawalCenter";//提现中心
import TransactionDetail from "@/views/income/TransactionDetail";//交易明细
import WeComNotify from "@/views/wecom/WeComNotify";//企业微信通知管理
import BannerManagement from "@/views/system/BannerManagement";//轮播图管理
import CollectiveDelivery from "@/views/system/CollectiveDelivery";//集送配置
import Coupon from "@/views/marketing/Coupon";//劵管理
import Point from "@/views/marketing/Point";//积分管理
import Exchange from "@/views/marketing/Exchange";//兑换中心
import CouponCampaign from "@/views/marketing/CouponCampaign";//发券活动

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { name: "Login", path: '/login', component: Login },
  {
    name: 'Home', path: '/home', component: home,
    children: [
      {
        name: "首页",
        path: "/homepage",
        component: Dashboard,
      },
      {
        name: "用户管理",
        path: "/user",
        component: User,
      },
      {
        name: "菜单管理",
        path: "/menu",
        component: Menu,
      },
        {
            name: "角色管理",
            path: "/role",
            component: SysRole,
        },
      // 校园管理
      {
        name: "动态管理",
        path: "/dynamic",
        component: Dynamic,
      },
      {
        name: "学校管理",
        path: "/school",
        component: School,
      },
      {
        name: "分成配置",
        path: "/school_commission",
        component: SchoolCommission,
      },
      {
        name: "个人中心",
        path: "/index",
        component: index,
      },
      {
        name: "兼职审核",
        path: "/parttime_audit",
        component: ParttimeAudit,
      },
      {
        name: "普通用户",
        path: "/campus_user",
        component: CampusUser,
      },
      {
        name: "兼职负责人",
        path: "/campus_job",
        component: CampusJob,
      },
      {
        name: "负责人分配",
        path: "/manager_assignment",
        component: ManagerAssignment,
      },
      {
        name: "店铺分类",
        path: "/shop_classification",
        component: shopClassification,
      },
      {
        name: "商品分类",
        path: "/product_classification",
        component: productClassification,
      },
      {
        name: "门面管理",
        path: "/shop",
        component: shop,
      },
      {
        name: "订单中心",
        path: "/sys_order",
        component: selectOrder,
      },
      {
        name: "退款中心",
        path: "/refund",
        component: selectRefund,
      },
      {
        name:"商品管理",
        path:"/product",
        component: product,
      },
      {
        name:"兼职收入",
        path:"/parttime_income",
        component: ParttimeIncome,
      },
      {
        name:"平台收入",
        path:"/platform_income",
        component: PlatformIncome,
      },
      {
        name:"提现中心",
        path:"/withdrawal_center",
        component: WithdrawalCenter,
      },
      {
        name:"交易明细",
        path:"/transaction_detail",
        component: TransactionDetail,
      },
      {
        name: "WeComNotify",
        path: "/wecom_notify",
        component: WeComNotify,
      },
      {
        name: "轮播图管理",
        path: "/banner_management",
        component: BannerManagement,
      },
      {
        name: "集送配置",
        path: "/collective_delivery",
        component: CollectiveDelivery,
      },
      {
        name: "劵管理",
        path: "/coupon",
        component: Coupon,
      },
      {
        name: "积分管理",
        path: "/point",
        component: Point,
      },
      {
        name: "兑换中心",
        path: "/exchange_core",
        component: Exchange,
      },
      {
        name: "发券活动",
        path: "/coupon_campaign",
        component: CouponCampaign,
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

//路由守卫
router.beforeEach((to, from, next) => {
  localStorage.setItem("currentPathName", to.name) //设置当前的路由名称
  store.commit("setPath") //触发store的数据更新
  next() //放行路由
})


export default router
